import { render, staticRenderFns } from "./PettyCashExpenseForm.vue?vue&type=template&id=1387d76b"
import script from "./PettyCashExpenseForm.vue?vue&type=script&lang=js"
export * from "./PettyCashExpenseForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports